export default "__VITE_ASSET__nh6pEM_e__"